<nz-drawer
  [nzClosable]="true"
  [nzVisible]="showEstimationDrawer"
  nzPlacement="right"
  [nzWidth]="'400px'"
  nzTitle="Nuevo folio de estimación"
  (nzOnClose)="close()"
>
  <form nz-form *nzDrawerContent
    class="create-estimation-form"
    [formGroup]="createEstimationForm">
    <div>
      <nz-form-item>
        <nz-form-control>
          <nz-form-label nzRequired nzFor="project">Proyecto</nz-form-label>
          <input nz-input id="project"
            formControlName="project"
            nzPlaceHolder="Selecciona un proyecto"
            [nzAutocomplete]="projectAutocomplete"
            (input)="onSearchProject($event)">
            <nz-autocomplete #projectAutocomplete (selectionChange)="onSelectProject($event)">
              @for (project of projects; track project) {
                <nz-auto-option
                  [nzValue]="project" [nzLabel]="project.projectName">
                  {{ project.projectName }}
                </nz-auto-option>
              }
            </nz-autocomplete>
        </nz-form-control>
      </nz-form-item>
  
      <nz-form-item>
        <nz-form-control>
          <nz-form-label for="company">Compañía</nz-form-label>
          <input nz-input id="company"
            formControlName="company"
            nzPlaceHolder="Selecciona una compañía">
        </nz-form-control>
      </nz-form-item>
  
      <nz-form-item>
        <nz-form-control>
          <nz-form-label nzRequired for="provider">Proveedor</nz-form-label>
          <input nz-input id="provider"
            formControlName="provider"
            nzPlaceHolder="Selecciona un proveedor"
            [nzAutocomplete]="providerAutocomplete"
            (input)="onSearchProvider($event)">
          <nz-autocomplete #providerAutocomplete
            (selectionChange)="onSelectProvider($event)">
            @for (provider of providers; track provider) {
              <nz-auto-option [nzValue]="provider"
                [nzLabel]="provider.providerLegalName">
                {{ provider.providerLegalName }}
              </nz-auto-option>
            }
          </nz-autocomplete>
        </nz-form-control>
      </nz-form-item>
  
      <nz-form-item>
        <nz-form-control>
          <nz-form-label nzRequired for="type">Tipo</nz-form-label>
          <nz-select formControlName="type" id="type"
            nzPlaceHolder="Selecciona un tipo">
            @for (type of types; track type) {
              <nz-option [nzValue]="type.id" [nzLabel]="type.label"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
  
      <nz-form-item>
        <nz-form-control>
          <nz-form-label nzRequired for="description">Descripción</nz-form-label>
          <nz-textarea-count [nzMaxCharacterCount]="300">
            <textarea formControlName="description" nz-input id="description"
              rows="3" [maxlength]="300"></textarea>
          </nz-textarea-count>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div class="create-estimation-button-container">
      <button nz-button nzType="primary" class="create-estimation-button"
        [disabled]="!createEstimationForm.valid" (click)="onCreateEstimation()">
        <span nz-icon nzType="arrow-right"></span>
        Crear e ir a la estimación
      </button>
    </div>
  </form>
</nz-drawer>